import axios from '@/plugins/axios'

export function getOrders(params = {}) {
  return axios.get('orders', {
    params,
  })
}
export function getOrdersByNo(params = {}) {
  return axios.get('orders/getByNo', {
    params,
  })
}

export function orderLocationsearch(params = {}) {
  return axios.get('orders/orderLocationsearch', {
    params,
  })
}

export function getOrderLocation(params = {}) {
  return axios.get('orders/orderLocation', {
    params,
  })
}

export function getOrdersStatus() {
  return axios.get('orders/orderStatus')
}

export function getOrderBikeOperate(params = {}) {
  return axios.get('orders/orderBikeOperate', {
    params,
  })
}

export function closeLock(data) {
  return axios.post('orders/closeLock', data)
}

export function settlementOrders(data) {
  return axios.post('orders/settlement', data)
}

export function orderDetailPosition(data) {
  return axios.post('orders/orderDetailPosition', data)
}

export function returnOrderMoney(data) {
  return axios.post('orders/returnOrderMoney', data)
}

export function changeOrderRiding(data) {
  return axios.post('orders/changeOrderRiding', data)
}

export function getTrajectory(data) {
    return axios.post('bike/getTrajectory', data)
}

export function BikeControByOrder(data) {
    return axios.post('orders/orderBikeContro', data)
}

export function updateOrders(id, data) {
    return axios.put(`orders/${id}`, data)
}

export function resetOrderNo(data) {
    return axios.post('orders/resetOrderNo', data)
}

export function getOrderUserAuthInfo(params = {}) {
  return axios.get('orders/orderUserAuthInfo', {
    params,
  })
}
